import axios from "axios";
import { apiBaseUrl } from "../constants/ApiConstants";

const getToken = () => localStorage.getItem("token");
const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + getToken(),
    apikey: "123",
  },
});

export default axiosInstance;
